import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const inputCls =
  "w-full min-h-[56px] rounded-xl border-2 border-slate-300 bg-white px-4 text-lg text-slate-900 placeholder:text-slate-400 transition-colors focus:border-emerald-600 focus:outline-none focus:ring-4 focus:ring-emerald-100";

export const Field = ({ id, label, hint, error, children }) => (
  <div className="space-y-2">
    <label htmlFor={id} className="block text-lg font-semibold text-slate-900">
      {label}
      {hint && <span className="ml-2 text-base font-normal text-slate-500">{hint}</span>}
    </label>
    {children}
    {error && (
      <p data-testid={`${id}-error`} className="text-base font-medium text-red-700">{error}</p>
    )}
  </div>
);

export const PasswordInput = ({ id, value, onChange, autoComplete }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        id={id}
        data-testid={`${id}-input`}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        className={`${inputCls} pr-28`}
        placeholder="Mínimo 6 caracteres"
      />
      <button
        type="button"
        data-testid={`${id}-toggle-visibility`}
        onClick={() => setShow((s) => !s)}
        className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex items-center gap-1 rounded-lg px-3 py-2 text-base font-semibold text-emerald-800 hover:bg-emerald-50"
      >
        {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
        {show ? "Ocultar" : "Mostrar"}
      </button>
    </div>
  );
};

export const PrimaryButton = ({ children, loading, className = "", ...props }) => (
  <button
    {...props}
    disabled={loading || props.disabled}
    className={`w-full min-h-[60px] rounded-2xl bg-emerald-700 px-6 font-heading text-xl font-bold text-white shadow-[0_6px_0_0_#064e3b] transition-[transform,box-shadow,background-color] duration-150 hover:bg-emerald-800 active:translate-y-[4px] active:shadow-[0_2px_0_0_#064e3b] disabled:opacity-60 flex items-center justify-center gap-3 ${className}`}
  >
    {loading ? "Aguarde..." : children}
  </button>
);

export const FormAlert = ({ testId, children }) =>
  children ? (
    <div data-testid={testId} role="alert" className="rounded-xl border-2 border-red-200 bg-red-50 px-4 py-3 text-lg font-medium text-red-800">
      {children}
    </div>
  ) : null;
